module.exports = __webpack_public_path__ + "img/logo.41033e9a.png";